import React from 'react';
import { Route } from 'react-router';
import Form from './welcomeMailForm';

export default (
  <Route path="boas-vindas">
    <Route path=":id/:action" component={(props) => <Form {...props} />} />
  </Route>
);
